import { SwatchBook } from 'lucide-react';
import { useTemplateStudioState } from 'state/hooks/template-studio.hook';

import { HeaderPanelControl } from './HeaderPanelControl';

export const BrandKitController: React.FC = () => {
  const { isBrandKitOpen, setIsBrandKitOpen, setIsPersonalizationOpen } =
    useTemplateStudioState();

  const handleClick = () => {
    setIsPersonalizationOpen(false);
    setIsBrandKitOpen(!isBrandKitOpen);
  };

  return (
    <HeaderPanelControl
      isOpen={!!isBrandKitOpen}
      onClick={handleClick}
      tooltip="Brand Kit"
      icon={<SwatchBook size={16} />}
    />
  );
};
